import { NSModal } from 'bricks';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import React from 'react';

interface IViewAllModalProps {
    isOpen: boolean;
    toggle: () => void;
    title: string;
    children: React.ReactNode;
}

const ViewAllModal = ({
    isOpen, toggle, title, children,
}: IViewAllModalProps) => (
    <NSModal
        isOpen={isOpen}
        toggle={toggle}
        modalHeaderText={title}
        modalHeaderClassName="bg-primary text-white"
        modalBodyClassName="py-1"
        scrollable
        customFooter={(
            <div>
                <NSButtonBase
                    className="ml-2"
                    text="Close"
                    color="primary"
                    outline={false}
                    callback={toggle}
                />
            </div>
        )}
    >
        {children}
    </NSModal>
);

export default ViewAllModal;
